import { render, staticRenderFns } from "./ProductSaleOrder.vue?vue&type=template&id=495a5b25&"
import script from "./ProductSaleOrder.vue?vue&type=script&lang=js&"
export * from "./ProductSaleOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports